import $ from 'jquery';
import 'slick-carousel';

function slickMain() {
  var elem = $('#slick-main').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      speed: 2000,
      arrows: false,
      autoplay: true,
      infinite:true,
      pauseOnHover: false,
      fade:true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

  }
}

function slickQualities() {
  var elem = $('#slick-qualities').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      speed: 2000,
      arrows: true,
      autoplay: true,
      infinite:true,
      pauseOnHover: false,
      fade: false,
      autoplaySpeed: 5000,
      prevArrow:"<div class='slick-prev prev pull-left'><i class='fas fa-arrow-left' aria-hidden='true'></i></div>",
      nextArrow:"<div class='slick-next next pull-right'><i class='fas fa-arrow-right' aria-hidden='true'></i></div>",
      responsive: [
        {
          breakpoint: 99999,
          settings: "unslick",
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
          }
        }
      ],
    });

  }
}

function slickTestimonials() {
  var elem = $('#slick-testimonials').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      speed: 2000,
      arrows: true,
      autoplay: true,
      infinite:true,
      pauseOnHover: false,
      fade: false,
      autoplaySpeed: 6000,
      prevArrow:"<div class='slick-prev prev pull-left'><i class='fas fa-arrow-left' aria-hidden='true'></i></div>",
      nextArrow:"<div class='slick-next next pull-right'><i class='fas fa-arrow-right' aria-hidden='true'></i></div>",
      slidesToShow: 1,
      slidesToScroll:1,
    });

  }
}

var init = function () {
  slickMain();
  slickQualities();
  slickTestimonials();
}

var tresize = function(){
  slickMain();
  slickQualities();
  slickTestimonials();
}

$(window).on('load', function () {
  init();
});

$(window).on('resize', function () {
  tresize();
});
